import React, { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cad_cart") || "[]"); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("cad_cart", JSON.stringify(items));
  }, [items]);

  function add(item) {
    setItems((prev) => {
      // treat different customizations as different lines
      const key = JSON.stringify({ id: item.product_id, v: item.variant, c: item.customizations });
      const idx = prev.findIndex((p) => p._key === key);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + (item.quantity || 1) };
        return next;
      }
      return [...prev, { ...item, _key: key, quantity: item.quantity || 1 }];
    });
  }
  const remove = (key) => setItems((prev) => prev.filter((p) => p._key !== key));
  const setQty = (key, qty) => setItems((prev) => prev.map((p) => (p._key === key ? { ...p, quantity: Math.max(1, qty) } : p)));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + (i.quantity || 1), 0);
  const subtotal = items.reduce((s, i) => {
    let unit = i.unit_price || 0;
    Object.values(i.customizations || {}).forEach((c) => {
      if (c && typeof c === "object" && c.price_add) unit += c.price_add;
    });
    return s + unit * (i.quantity || 1);
  }, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, setQty, clear, count, subtotal }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
